  <template>
    <form @submit.prevent  data-vv-scope="caseCodeForm">
        <div class="form-container form_container">
             <VuePerfectScrollbar	
            ref="mainSidebarPs"	
            class="scroll-area--main-sidebar"	
            :settings="settings"	
            @ps-scroll-y="scrollEvent"	
            id="listItems"
          >

         

           <div class="vx-row" v-if="[1].indexOf(getUserRoleId) > -1">
                <div class="vx-col w-50">
                    <div class="form_group pl-6">            
                        <div class="con-select">
                            <label class="form_label mb-0">Customer<em>*</em></label>              
                            <multiselect
                            v-model="tenantDetails"
                            :options="tenantsList"
                            :multiple="false" :hideSelected="true"
                            :close-on-select="true"
                            :clear-on-select="false"
                            :preserve-search="true"
                            placeholder="Select "
                            label="name"
                            track-by="_id"
                            :preselect-first="false"
                            data-vv-as="Customer"
                            v-validate="'required'"
                            name="customer"
                            :disabled="isEdit"
                            @input="getPetitionConfigList()"
                            
                            > 
                            <template slot="selection" slot-scope="{ values, isOpen }">
                                <span
                                class="multiselect__selectcustom"
                                v-if="values.length && !isOpen"
                                >{{ values.length }} Customer(s) Selected</span
                                >
                                <span
                                class="multiselect__selectcustom"
                                v-if="values.length && isOpen"
                                ></span>
                            </template>
                            </multiselect>
                        </div>
                        <span class="error_msg"  v-show="errors.has('caseCodeForm.customer')" >{{ errors.first("caseCodeForm.customer") }}</span>
                    </div>
                </div>
            </div>
            <div>
            <div class="code-cofig-sec " :class="{'code-cofig-sec-edit':isEdit}"  @click="conf.errorMsg='';formerrorsMsg=''"  v-for="( conf ,index ) in newform" :key="index"    >
                <span class="remove_sec" v-if="index>0 && !isEdit"  @click="removeMainItem(index)"><img src="@/assets/images/main/delete-row-img.svg" alt="trash-img" width="15"></span>
                <div class="vx-row">
                    <div class="vx-col w-50">
                            <div class="form_group d-block case-sub-types">
                            <label class="form_label">Case Subtypes<em>*</em></label>
                                <div class="con-select w-full">
                                                      
                                <multiselect
                                    :name="'subTypeDetails_'+index"
                                    v-model="conf.subTypeDetails"
                                    :options="petitionConfigList"
                                    :multiple="true"
                                    :close-on-select="false"
                                    :clear-on-select="false"
                                    :preserve-search="true"
                                    placeholder="Select "
                                   v-validate="'required'"
                                    :preselect-first="false"
                                    data-vv-as=" Case Subtypes"
                                                    
                                    group-values="subTypes"
                                    group-label="caseType" 
                                    :group-select="true" 
                                
                                    track-by="name" 
                                    label="name"
                                    @input="resetSubTypes(conf)"
                                    
                                    
                                
                                > 
                                    <template slot="selection" slot-scope="{ values, isOpen }">
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && !isOpen"
                                    >{{ values.length }} Case Type(s) Selected</span
                                    >
                                    <span
                                    class="multiselect__selectcustom"
                                    v-if="values.length && isOpen"
                                    ></span>
                                    </template>
                                </multiselect>
                                
                                </div>
                                <span   class="error_msg" v-show="errors.has('caseCodeForm.subTypeDetails_'+index)"  >{{ errors.first("caseCodeForm.subTypeDetails_"+index) }}</span>
                            
                            </div>
                    </div>
                </div>
            <!----configDetails caseTypeDetails-->           
                <div class="w-full">
                    <div class="code-config-wrap">
                        <div class="code-config-left">
                            <div class="code-config-list">
                               <template  v-for="( confItem ,ind) in conf['configDetails']" >
                                    <div class="code-config" :key="ind" v-if="(checkProperty(conf ,'configDetails' ,'length'))-1!=ind" >
                                        <div class="form_group">
                                            <span class="delete" v-if="conf['configDetails'].length>3" @click="removeConfigItem(conf['configDetails'],ind ,conf)"><img src="@/assets/images/main/delete-row-img.svg" alt="trash-img" width="15"></span>
                                            <label class="form_label">Select<em>*</em> </label>                            
                                            <div class="con-select w-full">  
                                                    
                                                <multiselect
                                                :name="'configCode_'+index+'_'+ind"
                                                v-model="confItem['config']"
                                                :options="conf.configItemsList"
                                                :multiple="false"
                                                :close-on-select="true"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Select"
                                                label="name"
                                                track-by="id"
                                                :preselect-first="false"
                                                data-vv-as="Value"
                                                v-validate="'required'"
                                                @input="configSelected(conf)"
                                                
                                                
                                                > 
                                                <template slot="selection" slot-scope="{ values, isOpen }">
                                                    <span
                                                    class="multiselect__selectcustom"
                                                    v-if="values.length && !isOpen"
                                                    >{{ values.length }} Case config(s) Selected</span
                                                    >
                                                    <span
                                                    class="multiselect__selectcustom"
                                                    v-if="values.length && isOpen"
                                                    ></span>
                                                </template>
                                                </multiselect>                                
                                            </div>
                                            <span class="error_msg" v-show="errors.has('caseCodeForm.configCode_'+index+'_'+ind)"  >{{ errors.first('caseCodeForm.configCode_'+index+'_'+ind) }}</span>
                                        </div>  
                                        <em class="config-separater">-</em>                          
                                    </div>
                                </template>                        
                                <span class="add-more" v-if="conf['configDetails'].length<=6" @click="addnewConfigItem(conf['configDetails'] ,conf)" ><span>+</span></span>
                                <template v-for="( confItem ,ind) in conf['configDetails']" >
                                    <div class="form_group config"  :key="ind"  v-if="(checkProperty(conf ,'configDetails' ,'length'))-1==ind" >
                                    <label class="form_label">Select<em>*</em> </label>
                                        <div class="con-select w-full">                            
                                            <multiselect
                                                :name="'configCode_'+index+'_'+ind"
                                                v-model="confItem['config']"
                                                :options="conf.configItemsList"
                                                :multiple="false"
                                                :close-on-select="true"
                                                :clear-on-select="false"
                                                :preserve-search="true"
                                                placeholder="Select"
                                                label="name"
                                                track-by="id"
                                                :preselect-first="false"
                                                data-vv-as="Value"
                                                v-validate="'required'"
                                                :disabled="true"
                                                @input="configSelected(conf)"
                                            > 
                                                <template slot="selection" slot-scope="{ values, isOpen }">
                                                <span
                                                class="multiselect__selectcustom"
                                                v-if="values.length && !isOpen"
                                                >{{ values.length }} Selected</span
                                                >
                                                <span
                                                class="multiselect__selectcustom"
                                                v-if="values.length && isOpen"
                                                ></span>
                                                </template>
                                            </multiselect>
                                        </div>
                                        <span class="error_msg" v-show="errors.has('caseCodeForm.resetIdBy'+index)"  >{{ errors.first("caseCodeForm.resetIdBy"+index) }}</span>
                                    </div>
                                </template>
                            </div>
                        </div> 
                    </div>
                    
                    <!-- <span v-if="(conf['configDetails'].length)-1 ==ind && conf['configDetails'].length <(conf.configItemsList.length)"   @click="addnewConfigItem(conf['configDetails'] ,conf)" >Add</span> -->
                    <!-- <span class="add-more d-inline-flex ml-0 mb-6"  @click="addnewConfigItem(conf['configDetails'] ,conf)" ><span>Add</span></span> -->

                    <div class="vx-row"  v-if="conf.caseCode!=''">                
                        <div class="vx-col w-full">
                        <div class="form_group d-block">
                            <label class="form_label">Example Case ID</label>
                            <p class="examplecode">{{conf.caseCode}}</p>
                        </div>
                        </div>       
                    </div>    

                    <div class="vx-row">
                        <div class="vx-col w-50">
                        <div class="form_group">
                            <label class="form_label">SI. No. Starts From<em>*</em>
                            <div class="IB_tooltip" v-if="false">
                                    <span
                                    ><info-icon size="1.5x" class="custom-class"></info-icon
                                    ></span>
                                    <div class="tooltip_cnt">
                                    <p>
                                    Serial Number Starts From
                                    </p>
                                    </div>
                            </div>
                            
                            </label>
                            <vs-input
                            :disabled="isEdit"
                            type="number"
                            v-model="conf.sNoStartsFrom"  
                            @input="prePareCaseCode(conf)"
                            oninput="this.value = this.value.replace(/[^0-9]/g, '').replace(/(\..*)\./g, '$1'); this.value = this.value.replace(/ /g,'');"
 
                            :name="'sNoStartsFrom_'+index"
                            v-validate="'required|numeric|min_value:1'"
                            class="w-full"
                            data-vv-as="SI. No."
                            />
                            <span class="error_msg"  v-show="errors.has('caseCodeForm.sNoStartsFrom_'+index)" >{{ errors.first("caseCodeForm.sNoStartsFrom_"+index) }}</span >
                        </div>                        
                        </div>
                      
                    </div>
                
                 
                    <div class="vx-row" v-if="checkProperty( conf,'showResetIdBy') ==true">
                  
                        <div class="vx-col w-50"   >
                            <div class="form_group d-block">
                                <label class="form_label">SI. No. Reset On</label>
                                <div class="con-select w-full">                            
                                    <multiselect
                                        :name="'resetIdBy'+index"
                                        v-model="conf.resetIdBy"
                                        :options="conf.resetIdByList"
                                        :multiple="false"
                                        :close-on-select="true"
                                        :clear-on-select="false"
                                        :preserve-search="true"
                                        placeholder="Select "
                                    
                                        :preselect-first="false"
                                        data-vv-as=" Reset By"
                                                                
                                        
                                        
                                    
                                    > 
                                        <template slot="selection" slot-scope="{ values, isOpen }">
                                        <span
                                        class="multiselect__selectcustom"
                                        v-if="values.length && !isOpen"
                                        >{{ values.length }} Selected</span
                                        >
                                        <span
                                        class="multiselect__selectcustom"
                                        v-if="values.length && isOpen"
                                        ></span>
                                        </template>
                                    </multiselect>
                                </div>
                                <span class="error_msg" v-show="errors.has('caseCodeForm.resetIdBy'+index)"  >{{ errors.first("caseCodeForm.resetIdBy"+index) }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="vx-row" v-if="checkProperty(conf ,'errorMsg') ">
                        <div class="vx-col w-100"   >
                            <div class="form_group d-block">
                                    <div class="formerrors" >
                                    <vs-alert
                                    color="warning"
                                    class="warning-alert reg-warning-alert no-border-radius  mb-0"
                                    icon-pack="IntakePortal"
                                    icon="IP-information-button"
                                    active="true"
                                    >{{checkProperty(conf ,'errorMsg') }} </vs-alert>
                                    </div>
                            
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <span class="delete_row"><img src="@/assets/images/main/delete-row-img.svg" alt="trash-img" width="15"></span> -->
            </div> 
            </div>
            <div class="code-config-more" v-if="!isEdit">
                <a class="add-more ml-0" type="filled" @click="setNewForm(false)">
                    <span>+</span> More
                </a>
            </div>  
            </VuePerfectScrollbar> 
            
        </div>

         <div class="text-danger text-sm formerrors" v-show="formerrorsMsg">
                <vs-alert
                color="warning"
                class="warning-alert reg-warning-alert no-border-radius  mb-0"
                icon-pack="IntakePortal"
                icon="IP-information-button"
                active="true"
                >{{formerrorsMsg }}</vs-alert>
        </div>


        <div class="popup-footer relative">
        <vs-button
            color="dark"
            @click="hideAddPopup();  "
            class="cancel"
            type="filled"
            >Cancel</vs-button
        >

        <vs-button
            :disabled="creatingNew"
            v-if="isEdit"
            color="success"
            class="save"
            @click="updateAction()"
            type="filled"
            >Update</vs-button
        >

        <vs-button
            :disabled="creatingNew"
            v-else
            color="success"
            class="save"
            @click="createNewAction()"
            type="filled"
            >Save</vs-button
        >
        </div>
        
    </form>
</template>
<script>
import _ from "lodash";
import moment from "moment";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
  // import the styles
   import JQuery from "jquery";
 import { InfoIcon } from 'vue-feather-icons' 
export default {
     components: { 
        VuePerfectScrollbar,
        InfoIcon

      },
     data: () => ({
         tenantsList:[],
         settings: { 
        swipeEasing: false,
      },
      caseTypesList:[],
      caseSubTypesList:[],
        resetIdBy:["Month", "Year"],
        selectedConfigItem:null,
       petitionerList:[],
       selectedPetitioner :{ 'customId':'srinfotech-COMPANY-16',"name": "srinfotech"},
      caseType:{ "caseType": "H-1B", "subTypes": [ { "id": 1, "name": "Amendment", "label": "Amendment" }]},
      caseSubType :{ "id": 1, "name": "Amendment", "label": "Amendment" },

        caseCode:'',
         caseTypeList:[],
        creatingNew:false,
        formerrorsMsg:'',
        "configItem": { "config": ""},
        configItemsList:[],
        configItemsListTemp:[],
         newform: [],
    petitionConfigList:[],
    petitionConfigListTemp:[],
    tenantDetails:null

     }),
     methods: {

         prePareCaseCode(configItem){
        this.caseCode ='';
        let tempCaseCodeList =[];

          
       //  configItem['resetIdByList'] =["Month", "Year"];
     //  alert(JSON.stringify(configItem['subTypeDetails']));

       
        _.forEach(configItem.configDetails ,(item ,index)=>{
           
              if(_.get(item ,"config.id")){
              // alert( _.get(item ,"config.id"))
              }
             //CUSTOMER_CODE 
            if(_.get(item ,"config.id")=="CUSTOMER_CODE"){

                
                if(this.checkProperty(this.selectedPetitioner ,"idPrefix")){

                     let customId =   _.cloneDeep(this.checkProperty(this.selectedPetitioner ,"idPrefix"))
                    customId =customId.toUpperCase();
                    tempCaseCodeList.push(customId);
                    
                } else if(this.checkProperty(this.selectedPetitioner ,"customId")){
                    let customId =   _.cloneDeep(this.checkProperty(this.selectedPetitioner ,"customId"))
                    customId =customId.toUpperCase();
                    tempCaseCodeList.push(customId);

                }
                
                
            }else if(_.get(item ,"config.id")=="CASE_TYPE_CODE"){
                //this.petitionConfigList
                    if(this.checkProperty(configItem ,'seletedTypeSubTypeDetails' ,"caseMainType") && (_.get(configItem ,"seletedTypeSubTypeDetails.caseMainType.code") || _.get(configItem ,"seletedTypeSubTypeDetails.caseMainType.name") )){
                     let caseCode ="H-1B";
                    if(_.get(configItem ,"seletedTypeSubTypeDetails.caseMainType.code")){
                       caseCode =  configItem["seletedTypeSubTypeDetails"]["caseMainType"]["code"];
                        

                    }else{
                         caseCode = _.cloneDeep( configItem["seletedTypeSubTypeDetails"]["caseMainType"]["name"]);
                       

                    }
                     caseCode = caseCode.toUpperCase();
                     tempCaseCodeList.push(caseCode);


                }else if(this.checkProperty(this.caseType ,"code")){
                       tempCaseCodeList.push(this.caseType['code'].toUpperCase());
                    }else{
                        tempCaseCodeList.push(this.caseType['caseType'].toUpperCase());
                    }

              
                 
               
               
                
            }else  if(_.get(item ,"config.id")=="CASE_SUBTYPE_CODE"){
                if(this.checkProperty(configItem ,'seletedTypeSubTypeDetails' ,"caseSubType") && (_.get(configItem ,"seletedTypeSubTypeDetails.caseSubType.code") || _.get(configItem ,"seletedTypeSubTypeDetails.caseSubType.name") )){
                    let csb ="Amendment";
                    if(_.get(configItem ,"seletedTypeSubTypeDetails.caseSubType.code")){
                       csb = _.cloneDeep( configItem['seletedTypeSubTypeDetails']['caseSubType']['code'])
                       

                    }else{
                          csb = _.cloneDeep(configItem['seletedTypeSubTypeDetails']['caseSubType']['name'])
                        

                    }
                    csb = csb.toUpperCase();
                    tempCaseCodeList.push(csb);


                }else if(this.checkProperty(this.caseSubType ,"code")){

                 tempCaseCodeList.push(this.caseSubType['code'].toUpperCase());

               }else{
                 tempCaseCodeList.push(this.caseSubType['name'].toUpperCase());

               }
               //
              
                
                
            }else if(_.get(item ,"config.id")=="PETITIONER_NAME"){
                 let petName = "Christopher";
                 if(this.checkProperty(this.selectedPetitioner ,"name")){
                    petName = this.selectedPetitioner['name']
                 }
                 petName =petName.toUpperCase();

                let arr = petName.split(" ");
                for (var i = 0; i < arr.length; i++) {
                    arr[i] = arr[i].toUpperCase() + arr[i].slice(1);

                }
               let str2 = arr.join("_");
               tempCaseCodeList.push(str2); 
           
                
            }else if(_.get(item ,"config.id")=="BENEFICIARY_NAME"){
               
               tempCaseCodeList.push("JON_STEWART");
                
            }else if(_.get(item ,"config.id")=="SPONSOR_NAME"){
               
                tempCaseCodeList.push("WILLIAM");
                
            }else if(_.get(item ,"config.id")=="APPLICANT_NAME"){
                            
                  tempCaseCodeList.push("JAMES_LEW");
            }else if(_.get(item ,"config.id")=="YYYY"){
               
                tempCaseCodeList.push(moment().format('YYYY'));
                configItem['resetIdByList'] =[ "Year"];
 
                
            }else if(_.get(item ,"config.id")=="MMDDYYYY"){
               
                tempCaseCodeList.push(moment().format('MMDDYYYY'));
                configItem['resetIdByList'] =["Day"];
                

            }else if(_.get(item ,"config.id")=="MMDDYY"){
               
               tempCaseCodeList.push(moment().format('MMDDYY'));
               configItem['resetIdByList'] =["Day" ,"Month" ,'Year'];
               configItem['resetIdByList'] =["Day"];
               

           }else if(_.get(item ,"config.id")=="MMYYYY"){
               
               tempCaseCodeList.push(moment().format('MMYYYY'));
               configItem['resetIdByList'] =["Month"];
               

           }else if(_.get(item ,"config.id") =="SI_NO"){
                tempCaseCodeList.push(configItem.sNoStartsFrom);
               
            }
            if(this.checkProperty( tempCaseCodeList ,"length")>0){
                 configItem.caseCode =tempCaseCodeList.join("-");
            }
           


            

        })

      },
        resetSubTypes(configItem){
            // {{petitionConfigList}} subTypeDetails  tempCaseType:null,  tempCaseSubType:null
           
             
    
            let selectedSubTypes =[];
            _.forEach(this.newform ,(config)=>{
                if(this.checkProperty(config , "subTypeDetails","length" )){
                     let tempselectedSubTypeIds =[];
                         config['subTypeDetails'].map((subType)=>{
                        selectedSubTypes.push(subType.id);
                        tempselectedSubTypeIds.push(subType.id);
                    })


                    if( tempselectedSubTypeIds.length>0){

                        _.forEach(this.petitionConfigListTemp ,(mainTypItem)=>{
                            let caseT ={  "caseType": "", "caseTypeId": '', code:'' }
                                caseT['caseType']  =this.checkProperty( mainTypItem, 'caseType');
                                caseT['caseTypeId']  =this.checkProperty( mainTypItem, 'caseType');
                                caseT['code']  =this.checkProperty( mainTypItem, 'code');
                                caseT['name']  =this.checkProperty( mainTypItem, 'caseType');

                            if(this.checkProperty(mainTypItem ,'subTypes' ,'length') >0){
                                 _.forEach(mainTypItem['subTypes'] , (subItem) => {

                                     let subTypeId = tempselectedSubTypeIds[_.random(tempselectedSubTypeIds.length-1)];
                                        if(subTypeId == subItem['id'] ){
                                            // "caseType": "H-1B", "caseTypeId": 1,
                                            config['seletedTypeSubTypeDetails'] ={
                                                'caseMainType':caseT,
                                                "caseSubType":subItem

                                            }

                                        }

                                 })

                               

                            }


                        });

                    }else{
                        config['seletedTypeSubTypeDetails'] =null;

                    }

                    


                   
                }

            });

             let petitionConfigList =  _.cloneDeep(this.petitionConfigListTemp);
             this.petitionConfigList =[];
            this.caseTypesList =[];
            this.caseSubTypesList =[];
             _.forEach(petitionConfigList , (mainTypeItem) => {
              
                let groupItem = {
                    caseType:'',
                    caseTypeId:'',
                   "subTypes":[],
                   "code":''
                }
                 groupItem['caseTypeId'] =mainTypeItem['caseTypeId'] ;
                 groupItem['caseType'] =mainTypeItem['caseType'] ;
                 groupItem['code']=  this.checkProperty(mainTypeItem ,"code");

                 let caseType ={"name":mainTypeItem['caseType'] ,"id":mainTypeItem['caseTypeId'] ,"code":""};
                 caseType['code']=  this.checkProperty(mainTypeItem ,"code");

                 this.caseTypesList.push(caseType)
            
                  if(this.checkProperty(mainTypeItem ,'subTypes' ,'length') >0){

                     _.forEach(mainTypeItem['subTypes'] , (subItem) => {
                            if( this.checkProperty( subItem,'isCaseTypeSelected') !=false && selectedSubTypes.indexOf(subItem['id']) <= -1 ){
                               let stype= {"id":subItem['id'],"name":subItem['name'] ,"label":subItem['name'] ,"code":''};
                                stype['code']=  this.checkProperty(subItem ,"code")
                                groupItem['subTypes'].push(stype)

                            }
                     })

                   
                    if(this.checkProperty(groupItem ,'subTypes' ,'length')>0){
                        this.petitionConfigList.push(groupItem);
                    }
                  }
             



             });

        
          this.caseType = this.petitionConfigList[_.random(this.petitionConfigList.length-1)];
         
         
          if(this.checkProperty(this.caseType ,'subTypes' ,'length' )>0){
             this.caseSubType = this.caseType['subTypes'][_.random(this.caseType['subTypes'].length-1)];
             
          }else{

              this.caseType = { "caseType": "H-1B", "subTypes": [ { "id": 1, "name": "Amendment", "label": "Amendment" }]};
              this.caseSubType ={ "id": 1, "name": "Amendment", "label": "Amendment" }

          }
          if(configItem){
           
            this.prePareCaseCode(configItem);
          }
          
           

        },
        scrollDown(){
 //comments
 //if( this.checkProperty(this.comments ,'length') == index+1){
   setTimeout(()=>{
       const $ = JQuery;
       let id = "listItems"
      // const element = document.getElementById(id);
     //  element.scrollTop = element.scrollHeight;

        const element = $(`#${id}`);
        element.animate({
        scrollTop: element.prop("scrollHeight")
        }, 10);
      
      
     
    },50)
    //}

        },

         getenants() {
        let matcher = {};
        let query = {};
        query['page'] = 1;
        query['perpage'] = 10000;
         query['getMasterData'] = true;
        query['filters'] = matcher;
              

        this.$store
          .dispatch("getList",{data:query ,path:'/tenant/list'} )
          .then(response => {
            this.tenantsList = response.list;

          });
        },
        changedType(item){
            this.caseSubTypesList =[];
            if(_.has(item ,"id")){
               if( _.find(this.petitionConfigList ,{"caseTypeId":item['id']})){
                let fitem = _.find(this.petitionConfigList ,{"caseTypeId":item['id']})
                if(_.has(fitem ,'subTypes')){
                     this.caseSubTypesList = fitem['subTypes'];
                }
                  

               }

            }

        },
        resetCasesubTypes(){
            
             this.caseSubTypesList = []
        },
        scrollEvent(event){},
        getPetitionersList(){
            
            let postData = {
                "page":1,
                "perpage":25,
                "matcher":
                    {
                        "searchString":"s",
                        "statusIds":[],
                        "countryIds":[],
                        "stateIds":[],
                        "locationIds":[],
                        "createdDateRange":[],
                        "statusList":[]
                    },
                "sorting":{
                    "path":"createdOn",
                    "order":-1
                    }
            };
      this.$store
        .dispatch("commonAction", { data: postData, path: "/company/list" })
        .then((response) => {

           this.petitionerList= response.list;
           if(this.checkProperty(this.petitionerList ,'length')>0){
              this.selectedPetitioner = this.petitionerList[_.random( this.petitionerList.length-1)];

           }
          
        })
        },
        getPetitionConfigList() {
      
      
      let postData = {
          "filters":{
            "tenantIds": [], // Send only for roles 1 and 2
            "tenantCustomId":"",
            "statusList": [],
            "activeList": [],
            "typeIds": [],
            "subTypeIds": [],
            "statusList": [],
            "createdDateRange": []
          },
          "page": 1, // Optional when 'getAll' send as 'true'
          "perpage": 100000000,// Optional when 'getAll' send as 'true'
          "getAll": true, // Send as 'true' to get all list
          "getByPetitionType":true
          
	};
    if(this.checkProperty(this.tenantDetails ,"customId") && [1,2].indexOf(this.getUserRoleId)>-1){
        postData['filters']['tenantCustomId']= this.tenantDetails['customId'];
    }
    this.petitionConfigList =[];
     this.petitionConfigListTemp =[];

      this.$store
        .dispatch("commonAction", { data: postData, path: "/petition-config/list" })
        .then((response) => {
            let petitionConfigList = response.list;
            this.caseTypesList =[];
             _.forEach(petitionConfigList , (mainTypeItem) => {
                if( this.checkProperty( mainTypeItem,'isCaseTypeSelected') !=false){
                let groupItem = {
                    caseType:'',
                    caseTypeId:'',
                   "subTypes":[],
                   "isSelected":true,
                   "isCaseTypeSelected":true,
                   code:'',
                }
                 groupItem['caseTypeId'] =mainTypeItem['id'] ;
                 groupItem['caseType'] =mainTypeItem['name'] ;
                groupItem['code'] = this.checkProperty( mainTypeItem ,'code') ;
              
                 let caseType ={"name":mainTypeItem['name'] ,"id":mainTypeItem['id']}
                 this.caseTypesList.push(caseType)
            
                  if(this.checkProperty(mainTypeItem ,'subTypes' ,'length') >0){

                     _.forEach(mainTypeItem['subTypes'] , (subItem) => {
                            if( this.checkProperty( subItem,'isCaseTypeSelected') !=false){
                               let sbItem =  {"id":subItem['id'], "isSelected":true, "isCaseTypeSelected":true,"name":subItem['name'] ,"label":subItem['name'] ,"code":''}
                                sbItem['code'] = this.checkProperty( subItem ,'code') ;
                                
                                groupItem['subTypes'].push(sbItem);

                            }
                     })

                    // groupItem['subTypes'] = mainTypeItem['subTypes'].map((subItem)=>{
                    //     return {"id":subItem['id'],"name":subItem['name'] ,"label":subItem['name']}
                    // })
                    if(this.checkProperty(groupItem ,'subTypes' ,'length')>0){
                        this.petitionConfigList.push(groupItem);
                        this.petitionConfigListTemp.push(groupItem);
                    }
                  }
             }



             });

        
          this.caseType = this.petitionConfigList[_.random(this.petitionConfigList.length-1)];
         
          if(this.checkProperty(this.caseType ,'subTypes' ,'length' )>0){
             this.caseSubType = this.caseType['subTypes'][_.random(this.caseType['subTypes'].length-1)];
             
          }else{

              this.caseType = { "caseType": "H-1B", "subTypes": [ { "id": 1, "name": "Amendment", "label": "Amendment" }]};
              this.caseSubType ={ "id": 1, "name": "Amendment", "label": "Amendment" }

          }
           
        });
        },
        hideAddPopup(){
            this.$emit('hideAddPopup')
        },
        reloadList(){
            this.$emit('reloadList')
        },

        processData(citem){
            citem['config'] = [];
             
            _.forEach(citem['configDetails'] ,(item)=>{
                if(this.checkProperty(item ,"config" ,'id') &&this.checkProperty(item ,"config" ,'name') ){
                    let configItem ={"id":'',"name":""};
                    configItem['id'] = this.checkProperty(item ,"config" ,'id');
                    configItem['name'] = this.checkProperty(item ,"config" ,'name');
                    citem['config'].push(_.cloneDeep(configItem));
                }
              
            })
           
          
             

        },

        createNewAction() {
          
            this.formerrorsMsg ='';
            this.$validator.validateAll('caseCodeForm').then((result) => {
                //"SI_NO"
                let inValied=0;
              this.creatingNew = false;
            if(result){
                
                let  postData =[];
                let newform  = _.cloneDeep(this.newform)
                _.forEach(this.newform,(formItem)=>{
                    let item ={
                        "groupCode": "", // APP, FAM // Optional
		                 "subTypeIds": [],
                         "config":[],
                         "sNoStartsFrom": "",
		                  "resetIdBy": false // Optional
                    }

                    item['groupCode'] = _.cloneDeep(this.checkProperty( formItem,'groupCode'));
                    if(this.checkProperty( formItem , "subTypeDetails" ,'length')>0) {
                         item['subTypeIds'] =  formItem['subTypeDetails'].map((item)=> item.id );
                    }
                     if(this.checkProperty( formItem , "configDetails" ,'length')>0) {
                         item['config'] =  formItem['configDetails'].map((item)=> item.config );
                     }
                    item['sNoStartsFrom'] = this.checkProperty( formItem,'sNoStartsFrom');
                    item['resetIdBy'] = this.checkProperty( formItem,'resetIdBy');
                    if(!(_.find(item['config'] ,{"id":'MMDDYY'}) || _.find(item['config'] ,{"id":'MMYYYY'}) || _.find(item['config'] ,{"id":'YYYY'}))){
                        item['resetIdBy'] ='';
                
                   }

                   if((_.find(item['config'] ,{"id":'SI_NO'}))){
                     formItem['errorMsg'] =''
                    
                   }else{
                    inValied =inValied+1;
                    formItem['errorMsg'] ="In Code Configuration Serial number is required"
                   }
                    postData.push(item);

                    



                })
              
                    if(inValied ==0){
                    let finalPostData = {
                        "items": postData,
                        
                    } 
                    if([1].indexOf(this.getUserRoleId) > -1 && this.checkProperty(this.tenantDetails ,"_id")){
                      finalPostData =Object.assign(finalPostData ,{"tenantId":this.tenantDetails['_id']})  
                    }   
                    this.creatingNew = true;
                    this.$store
                    .dispatch("commonAction", {"data":finalPostData ,"path":"/case-id-config/create"})
                    .then(response => {
                    
                    //lca_request_msg
                        this.reloadList();
                        this.showToster({message:response.message,isError:false });
                        this.hideAddPopup();
                        this.creatingNew = false;
                    
                                    
                    })
                    .catch((error)=>{
                    this.formerrorsMsg =error;
                        this.creatingNew = false;
                    })
                }
            }
            })
    
      },

    updateAction() {

   this.formerrorsMsg ='';
   this.$validator.validateAll('caseCodeForm').then((result) => {
    if(result){
        this.creatingNew = false;
      let inValied=0;
        
       let  postData =[];
              
                _.forEach(this.newform,(formItem)=>{
                    
                    let item ={
                        "groupCode": "", // APP, FAM // Optional
		                 "subTypeIds": [],
                         "config":[],
                         "sNoStartsFrom": "",
		                  "resetIdBy": '' ,// Optional,
                          configId:"",
                    }

                    item['groupCode'] = this.checkProperty( formItem,'groupCode');
                    if(this.checkProperty( formItem , "subTypeDetails" ,'length')>0) {
                         item['subTypeIds'] =  formItem['subTypeDetails'].map((item)=> item.id );
                    }
                     if(this.checkProperty( formItem , "configDetails" ,'length')>0) {
                         item['config'] =  formItem['configDetails'].map((item)=> item.config );
                     }
                    item['sNoStartsFrom'] = this.checkProperty( formItem,'sNoStartsFrom');
                    item['resetIdBy'] = this.checkProperty( formItem,'resetIdBy');

                     if(!( _.find(item['config'] ,{"id":'MMDDYY'}) || _.find(item['config'] ,{"id":'MMYYYY'}) || _.find(item['config'] ,{"id":'YYYY'}) )){
                        item['resetIdBy'] ='';
                 
                    }
                    postData.push(item);

                    if((_.find(item['config'] ,{"id":'SI_NO'}))){
                     formItem['errorMsg'] =''
                    
                   }else{
                    inValied =inValied+1;
                    formItem['errorMsg'] ="In Code Configuration Serial number is required"
                   }

                    



                })
                let finalPostData = postData[0];
                finalPostData['configId'] = this.checkProperty(this.editItem ,"_id");
                 if(inValied ==0){
                    this.creatingNew = true;
      
                            this.$store
                            .dispatch("commonAction", {"data":finalPostData ,"path":"/case-id-config/update"})
                            .then(response => {
                            
                            //lca_request_msg
                                this.reloadList();
                                this.showToster({message:response.message,isError:false });
                                this.hideAddPopup();
                                this.creatingNew = false;
                            
                                            
                            })
                            .catch((error)=>{
                            this.formerrorsMsg =error;
                                this.creatingNew = false;
                            })
                }
    }
    })
    
    },
         addnewConfigItem(arrayData ,item){
            let tempList =  [];
            let lastItem =null;
           
            _.forEach(arrayData ,( item ,index )=>{
                if((arrayData.length)-1 ==index){
                    
                     tempList.push(_.cloneDeep(this.configItem));
                     tempList.push(item);
                }else{
                     tempList.push(item);
                }
               
            });
            item.configDetails=tempList;
        
        this.configSelected(item)

      },
      removeConfigItem(arrayData ,index , item){
        arrayData.splice(index,1);
         this.configSelected(item)

      },
      removeMainItem(index =-1){
        if(index>0){
             this.newform.splice(index,1);
        }
        this.scrollDown();
        this.resetSubTypes();
       

      },
     setNewForm(isFromEdit=false){
       
        let configItem =    { 
              groupCode: "", 
              caseTypeDetails:null,
              subTypeIds:[],
              subTypeDetails:[],
             "config": [],
            configDetails:[], 
            sNoStartsFrom:10001,
            resetIdBy:'',
            caseCode:'',
            configItemsList:[],
            'showResetIdBy':true,
            "errorMsg":'',
            resetIdByList:["Month", "Year"],
            seletedTypeSubTypeDetails:null
           
            
          
           }
           if(!isFromEdit){
             let tempCOnfig = _.cloneDeep(this.configItem);
              let slItem=  { "_id": "62b569785dbbee33cc30ca16", "id": "CASE_TYPE_CODE", "name": "Case Type Code", "sortName": "case type code" };

             tempCOnfig['config'] = slItem;
             configItem['configDetails'].push(_.cloneDeep(tempCOnfig));


              slItem=  { "_id": "62b569785dbbee33cc30ca17", "id": "CASE_SUBTYPE_CODE", "name": "Case Subtype Code", "sortName": "case subtype code" };
              tempCOnfig['config'] = slItem;
              configItem['configDetails'].push(_.cloneDeep(tempCOnfig));

            slItem=  { "_id": "62b569785dbbee33cc30ca1e", "id": "SI_NO", "name": "Sl. No.", "sortName": "sl. no." };
            tempCOnfig['config'] = slItem;
            configItem['configDetails'].push(_.cloneDeep(tempCOnfig));

           }
          
           
           if(this.newform.length>0){
            
          this.$validator.validateAll('caseCodeForm').then((result) => {
             
                if(result){
                     this.newform.push(configItem) ;
                    this.getConfigItemsList();
                    // this.configSelected()
                    this.$validator.reset();
                    this.scrollDown();

                }
            })

           }else{
            this.newform.push(configItem) ;
             this.getConfigItemsList();
            // this.configSelected()
            this.$validator.reset();
            this.scrollDown();

           }
       
           
      },
     
     configSelected(item){
        
        this.configItemsList = _.cloneDeep(this.configItemsListTemp);
        let selectedItems = item.configDetails.map((item)=>item.config.id);
        item.configItemsList  = _.filter(this.configItemsListTemp ,(item)=>{
            return selectedItems.indexOf(item.id)<=-1

        })
        if(selectedItems.indexOf('YYYY')>-1){
            item.configItemsList  = _.filter( item.configItemsList ,(item)=>{
                 return item.id !='MMYYYY' && item.id !='MMDDYYYY'

             })
        }
         if(selectedItems.indexOf('MMYYYY')>-1){
             item.configItemsList  = _.filter( item.configItemsList ,(item)=>{
                 return item.id !='YYYY' && item.id !='MMDDYYYY'

             })
        }

        if(selectedItems.indexOf('MMDDYYYY')>-1){
             item.configItemsList  = _.filter( item.configItemsList ,(item)=>{
                 return item.id !='YYYY' && item.id !='MMYYYY'

             })
        }

           
           item['showResetIdBy'] = false;
            if( selectedItems.indexOf('MMYYYY') >-1 || selectedItems.indexOf('YYYY') >-1 || selectedItems.indexOf('MMDDYYYY') >-1 || selectedItems.indexOf('MMDDYY') >-1 ){
               
                item['showResetIdBy'] =true;
                 
            }else{
               item['resetIdBy'] ='';
            }

        this.processData(item);
        this.prePareCaseCode(item);
     },
     getConfigItemsList(){
        this.$store
      .dispatch("getmasterdata", "case_id_type")
      .then((response) => {
        let list = _.cloneDeep(response);

        if(this.getTenantTypeId ==2){
            list = _.filter(list ,(item)=>{ return item.id !="PETITIONER_NAME"  });
        }

       

        this.configItemsList = list;
        this.configItemsListTemp = _.cloneDeep(list);

         _.forEach(this.newform ,(item)=>{
            item['configItemsList'] =_.cloneDeep(list);
           
         })
          _.forEach(this.newform ,(item)=>{
          
            this.configSelected(item);
            this.resetSubTypes(item); 
         })
        
      });
  

     },
     },
     props: {
        editItem:null,
        isEdit:{
            type: Boolean,
            default: false
        }
     },
     mounted(){
        this.getPetitionersList();
        this.getPetitionConfigList();
        this.getenants();
       
        this.$store
      .dispatch("getmasterdata", "petition_types")
      .then((response) => {
        this.caseTypeList = response;
        //this.upDatehighestDegree();
      });
       
       if(this.isEdit && this.checkProperty(this.editItem ,"_id")){
        this.tenantDetails = this.checkProperty(this.editItem ,"tenantDetails")
            let itm =    { 
              groupCode: "", 
              subTypeIds:[],
              subTypeDetails:[],
             "config": [],
            configDetails:[], 
            sNoStartsFrom:10001,
            resetIdBy:'',
            caseCode:'',
            configItemsList:[],
            'showResetIdBy':false,
             "errorMsg":'',
             resetIdByList:["Month", "Year" ,'Day'],
              seletedTypeSubTypeDetails:null
            
          
           }
           
            _.forEach(this.editItem['config'] ,(item)=>{
                let configItem = {"config":null}
                configItem['config'] = _.cloneDeep(item);
                itm['configDetails'].push(_.cloneDeep(configItem))

            })
           
            //configDetails
            itm['subTypeDetails'] =[];
            if( this.checkProperty(this.editItem  ,'subTypeDetails' ,'length')>0){
               itm['subTypeDetails']  = this.editItem['subTypeDetails'];
            }
            if( this.checkProperty(this.editItem  ,'sNoStartsFrom' )){
                itm['sNoStartsFrom']  = this.editItem['sNoStartsFrom'];
            }
            
             if( this.checkProperty(this.editItem  ,'resetIdBy' )){
                itm['resetIdBy']  = this.editItem['resetIdBy'];
            }
            if(_.find(this.editItem['config'] ,{"id":'MMYYYY'}) || _.find(this.editItem['config'] ,{"id":'YYYY'})){
                itm['showResetIdBy'] =true;
                 
            }
           
            this.newform =[];
             this.newform.push(_.cloneDeep(itm));
            
            
             _.forEach(this.newform ,(item)=>{
                 this.processData(item);
                 this.prePareCaseCode(item);
                  
             });
            
          this.getConfigItemsList();
          // this.resetSubTypes();
        

       }else{
             this.setNewForm();
       }
     }
    
}
</script>